export default {
  setImages(images) {
    this.$state.images = images
  },
  setHasMorePages(value) {
    this.$state.hasMorePages = value
  },
  replaceImage(image) {
    const imageIndex = this.$state.images.findIndex((item) => item.id === image.id)

    if (imageIndex === -1) {
      return
    }

    this.$state.images[imageIndex] = image
  },
}
